import netLogo from './logo-net-new.png';
import betLogo from './logo-bet.png';

const logos = {
  net: netLogo,
  bet: betLogo,
}

const getLogo = () => {
  const domain = location.host.split('.').pop();
  return logos[domain] ?? logos.net;
}

export {
  getLogo,
}